
import React from "react";
import { useSelector } from "react-redux";
import PracticeDetailsPrintPopup from "../../Components/PracticeDetailsPrintPopup";
import FormatPhoneNumber from "../../../../../../../../../utils/FormatPhoneNumber";
import SignImagePreview from "../../Components/SignImagePreview";
import { formatDateTimeWithAt } from "../../Components/FormatDateTimeWithAt";
import { HPI_GROUPS, isSignedOrToBeCoSigned, ROS_GROUPS } from "../../Components/utils";
import CustomTemplateFormPreview from "../../Components/Custom Template Form/CustomTemplateFormPreview";
import EncDateStatus from "../../Components/Encounter Print Popup/EncDateStatus";
import SignData from "../../Components/SignData";

const SelectedPreviewDataV2 = ({ selectedItems, data, Data, searchParam, searchValue, ...props }) => {
    let { showAddressTypeLocation } = props;

    // let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    // let vitalData = data?.Vital?.[0]?.Vital?.reduce((acc, curr) => {
    //     acc[curr.VitalName] = curr.VitalValue;
    //     return acc;
    // }, {});

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }

    const removeTrailingEmptyLines = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }
    console.log("CurrentMentalStatusABC CurrentMentalStatus", Data?.CurrentMentalStatus,)
    let currentMentalStatusData = Object.keys(Data?.CurrentMentalStatus || {}).reduce((acc, key) => {
        acc[key] = props?.searchValueCMS?.[key] || '';
        return acc;
    }, {});
    let interventionsUsedData = Data?.InterventionsUsedData;
    let responseObservationsData = Data?.ResponseObservations;

    console.log("CurrentMentalStatusABC currentMentalStatusData", currentMentalStatusData)

    let noValExistTextNA = <p className="text ar-light-color">N/A</p>;
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;

    let objectiveNotesText = removeTrailingEmptyLines(Data?.ObjectiveNotes || '');
    // let goalsNotesText = removeTrailingEmptyLines(Data?.GoalsNotes || '');
    let interventionNotesText = removeTrailingEmptyLines(Data?.InterventionNotes || '');
    let responseNotesText = removeTrailingEmptyLines(Data?.ResponseNotes || '');
    let assessmentNotesText = removeTrailingEmptyLines(Data?.AssesmentNotes || '');
    let prescriptionsNotesText = removeTrailingEmptyLines(Data?.PrescriptionsNotes || '');
    let supplementsNotesText = removeTrailingEmptyLines(Data?.SupplementsNotes || '');
    let vaccinesNotesText = removeTrailingEmptyLines(Data?.VaccinesNotes || '');
    let injectionsNotesText = removeTrailingEmptyLines(Data?.InjectionsNotes || '');
    let labsNotesText = removeTrailingEmptyLines(Data?.LabsNotes || '');
    let imagingNotesText = removeTrailingEmptyLines(Data?.ImagingNotes || '');
    let planNotesText = removeTrailingEmptyLines(Data?.PlanNotes || '');
    let followUpNotesText = removeTrailingEmptyLines(Data?.FollowUpNotes || '');

    let additionalNoteText = removeTrailingEmptyLines(Data?.AdditionalInfoNotes || '');

    let historyOfPresentIllnessData = Data?.HistoryOfPresentIllness;
    let reviewOfSystemData = Data?.ReviewOfSystem;

    let historyofPresentIllnessNotesText = removeTrailingEmptyLines(Data?.HistoryofPresentIllnessNotes || '');
    let reviewOfSystemNotesText = removeTrailingEmptyLines(Data?.ReviewOfSystemNotes || '');

    console.log("selectedItemsselectedItems", selectedItems)

    const formattedUTC = data?.Data?.CurrentPracticeTime;
    let signatureDateTimeFormatted = formatDateTimeWithAt(data?.Data?.ProviderSignatureDate)
    let formattedUTCBottom = formattedUTC?.replace(',', ' at');

    const interventionCategories = {
        "Cognitive/Behavioral": [
            { key: "CognitiveChallenging", label: "Cognitive Challenging" },
            { key: "CognitiveReframing", label: "Cognitive Reframing" },
            { key: "CognitiveRefocusing", label: "Cognitive Refocusing" },
            { key: "CommunicationSkills", label: "Communication Skills" },
            { key: "DBT", label: "DBT" },
            { key: "PsychoEducation", label: "Psycho Education" },
            { key: "StructuredProblemSolving", label: "Structured Problem Solving" }
        ],
        "Emotional/Insight Based": [
            { key: "CrisisManagement", label: "Crisis Management" },
            { key: "ExplorationOfEmotions", label: "Exploration of Emotions" },
            { key: "ExplorationOfRelationshipPatterns", label: "Exploration of Relationship Patterns" },
            { key: "ExplorationOfCopingPatterns", label: "Exploration of Coping Patterns" },
            { key: "GuidedImagery", label: "Guided Imagery" },
            { key: "SymptomManagement", label: "Symptom Management" }
        ],
        "Supportive/Skill-Building": [
            { key: "EmotionalRegulationSkills", label: "Emotional Regulation Skills" },
            { key: "InteractiveFeedback", label: "Interactive Feedback" },
            { key: "InterpersonalResolutions", label: "Interpersonal Resolutions" },
            { key: "MindfulnessTraining", label: "Mindfulness Training" },
            { key: "RelaxationDeepBreathing", label: "Relaxation/Deep Breathing" },
            { key: "SupportiveReflection", label: "Supportive Reflection" }
        ],
        "Behavioral/Plan-Focused": [
            { key: "ComplianceIssues", label: "Compliance Issues" },
            { key: "PreventativeServices", label: "Preventative Services" },
            { key: "ReviewOfPlan", label: "Review of Plan" },
            { key: "RolePlayBehavioralRehearsal", label: "Role-Play/Behavioral Rehearsal" }
        ]
    };
    const riskAssessmentItems = [
        { key: "RiskLevel", label: "Level of Risk:" },
        { key: "RiskFactors", label: "Risk Factors:" },
        { key: "ProtectiveFactors", label: "Protective Factors:" },
    ];
    const CustomTemplateData = Data?.CustomTemplateData?.[0];
    const EncounterCoSignData = Data?.EncounterCoSignData?.filter(enc => [ true, "true"].includes(enc.isCoSigned));
        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (<>
        {/* {selectedItems?.patientSummary && */}
        <div className='d-flex flex-column gap-10 mb-15'>
            {/* <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light">
                    <p className="text fs-11 ar-light-color">{formattedUTC}</p>
                    <p className='text fs-11 ar-light-color'>{data?.Data?.UserName ? `(${data?.Data?.UserName})` : ''} {data?.Data?.PracticeShortName}</p>
                </div> */}
            <div className="d-flex align-items-center justify-content-center gap-12 pat-det-header">
                <div className="d-flex align-items-center gap-1">
                    <p className='heading text-white'>{data?.Data?.PatientName}</p>
                    <p className='text text-white'>{data?.Data?.DOB}</p>
                    <p className='text text-white'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</p>
                    <p className='text text-white'>{data?.Data?.Gender}</p>
                </div>
                <div className="text light-clrs">|</div>
                <div className="d-flex align-items-center gap-1">
                    <p className='text font-m text-white'>Account #</p>
                    <p className="text text-white">{data?.Data?.AccountNumber || noValExistTextNA}</p>
                </div>
                <div className="text light-clrs">|</div>
                <div className="d-flex align-items-center gap-1">
                    <p className='text font-m text-white'>DOS:</p>
                    <p className="text text-white">{searchParam?.EncounterDate || noValExistTextNA}</p>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                {console.log("dataqwertData", data?.Data)}
                <PracticeDetailsPrintPopup data={data?.Data} />
            </div>
            <div className=''>
                <div className="encounter-edit-mode-pdf p-2 d-flex flex-column gap-1">
                    <div className="col-md-12 p-0 d-flex gap-1">
                        <p className="heading validate-color fs-16 lh-15">{data?.Data?.PatientName}</p>
                        <span className='d-flex gap-1 align-items-center'>
                            <span className='text text-black'>{data?.Data?.DOB}</span> <span className='text text-black'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</span> <span className='text text-black'>{data?.Data?.Gender}</span>
                        </span>
                    </div>

                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Account #</p>
                                <p className="text text-black">{data?.Data?.AccountNumber || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Phone:</p>
                                <p className="text text-black">{data?.Data?.MobileNumber ? FormatPhoneNumber(data?.Data?.MobileNumber) : noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Address:</p>
                                <p className="text text-black">
                                    {selectedItems?.patientSummary ?
                                        (([true, "true"].includes(showAddressTypeLocation) ?
                                            data?.Data?.FacilityAddress : data?.Data?.Address)
                                            || noValExistTextNA) : noValExistTextNA}

                                </p>
                            </div>
                        </div>

                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Provider:</p>
                                <p className="heading validate-color">{searchValue.SeenBy || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Insurance:</p>
                                <p className="text text-black">{data?.Data?.InsuranceName || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Location:</p>
                                <p className="text text-black">{searchValue?.Facility || noValExistTextNA}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="mt-1 d-flex justify-content-between align-items-center px-2  py-1 br-bottom-1 za_br_light">
                        <div className={`signature-prview-box`}>
                            {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                                <>
                                    <SignImagePreview BucketPath={data?.Data?.SignaturePath} />
                                </> : <> </>}
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <div className="d-flex align-items-center gap-1">
                                {(searchValue?.EncounterStatus === 'Signed' || isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus)) ?
                                    <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                                    searchValue?.EncounterStatus === 'In Progress' ?
                                        <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                                        searchValue?.EncounterStatus === 'Ready for Review' ?
                                            <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                                            ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                                            <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>} {(searchValue?.EncounterStatus === 'Signed' || isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus)) ?
                                    <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                                    searchValue?.EncounterStatus === 'In Progress' ?
                                        <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                                        searchValue?.EncounterStatus === 'Ready for Review' ?
                                            <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                                            ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                                            <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}
                            </div>
                        </div>
                    </div> */}
            </div>
            <div className="d-flex align-items-center justify-content-between">
                
                <EncDateStatus searchParam={searchParam} searchValue={searchValue} noValExistTextNA={noValExistTextNA} data={data} Data={Data}/>
                <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center gap-1">
                        <p className="heading validate-color">Encounter Type:</p>
                        {searchValue?.EncounterType ?
                            <span className="text validate-color">{searchValue.EncounterType}</span>
                            :
                            <>{noValExistTextNA}</>}
                    </div>

                    <div className="d-flex align-items-center gap-1">
                        <p className="heading validate-color">Note Type:</p>
                        {searchValue?.NoteType ?
                            <span className="text validate-color">{searchValue.NoteType}</span>
                            :
                            <>{noValExistTextNA}</>}
                    </div>
                </div>
            </div>

        </div>
        {/* } */}
        <div className="d-flex flex-column gap-10">
            {selectedItems?.customTemplateClinical &&
                (CustomTemplateData?.InsertPosition === "Top" ?
                    <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
            {selectedItems?.chiefComplaint &&
                (<div className="d-flex flex-column gap-6">
                    <p className='text fs-14 font-b validate-color blue-bg w-max-content'>Chief Complaint</p>
                    <div>
                        <p className="text text-black">{Data?.ChiefComplaint || noValExistText}</p>
                    </div>
                </div>)}
            {selectedItems?.historyofPresentIllness &&
                <div className="d-flex flex-column gap-6">
                    <p className='text fs-14 font-b validate-color blue-bg w-max-content'>History of Present Illness(HPI)</p>
                    {/* {["Fields","Both"].includes(selectedItems.historyofPresentIllnessType) && */}
                    <div className="">
                        <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>HPI</p>
                        <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
                            {(() => {
                                const visibleGroups = HPI_GROUPS.map(group => ({
                                    ...group,
                                    selectedItems: group.items.filter(
                                        item => historyOfPresentIllnessData?.[item.key] === "true"
                                    ),
                                })).filter(group => group.selectedItems.length > 0);

                                return visibleGroups?.length > 0 ?
                                    visibleGroups.map((group, groupIndex) => (
                                        <React.Fragment key={group.title}>
                                            {group.title}:{" "}
                                            <span className="text">
                                                {group.selectedItems.map((item, itemIndex) => (
                                                    <React.Fragment key={item.key}>
                                                        {item.label}
                                                        {itemIndex < group.selectedItems.length - 1 && ", "}
                                                    </React.Fragment>
                                                ))}
                                                {groupIndex < visibleGroups.length - 1 ? ", " : ""}
                                            </span>
                                        </React.Fragment>
                                    )) : noValExistText
                            })()}
                        </p>
                    </div>
                    {/* } */}
                    {/* {["FreeText","Both"].includes(selectedItems.historyofPresentIllnessType) && */}
                    <div>
                        <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>HPI Notes</p>
                        {isVisuallyEmpty(Data.HistoryofPresentIllnessNotes) ?
                            noValExistText :
                            <p className="text" dangerouslySetInnerHTML={{ __html: historyofPresentIllnessNotesText }}></p>}
                    </div>
                    {/* } */}
                </div>}

            {selectedItems?.reviewOfSystem &&
                <div className="d-flex flex-column gap-6">
                    <p className='text fs-14 font-b validate-color blue-bg w-max-content'>Review of System(ROS)</p>
                    {/* {["Fields","Both"].includes(selectedItems.reviewOfSystemType) && */}
                    <div className="">
                        <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>ROS</p>
                        <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
                            {(() => {
                                const visibleGroups = ROS_GROUPS.map(group => ({
                                    ...group,
                                    selectedItems: group.items.filter(
                                        item => reviewOfSystemData?.[item.key] === "true"
                                    ),
                                })).filter(group => group.selectedItems.length > 0);

                                return visibleGroups?.length > 0 ?
                                    visibleGroups.map((group, groupIndex) => (
                                        <React.Fragment key={group.title}>
                                            {group.title}:{" "}
                                            <span className="text">
                                                {group.selectedItems.map((item, itemIndex) => (
                                                    <React.Fragment key={item.key}>
                                                        {item.label}
                                                        {itemIndex < group.selectedItems.length - 1 && ", "}
                                                    </React.Fragment>
                                                ))}
                                                {groupIndex < visibleGroups.length - 1 ? ", " : ""}
                                            </span>
                                        </React.Fragment>
                                    )) : noValExistText
                            })()}
                        </p>
                    </div>
                    {/* } */}
                    {/* {["FreeText","Both"].includes(selectedItems.reviewOfSystemType) && */}
                    <div>
                        <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>ROS Notes</p>
                        {isVisuallyEmpty(Data.ReviewOfSystemNotes) ?
                            noValExistText :
                            <p className="text" dangerouslySetInnerHTML={{ __html: reviewOfSystemNotesText }}></p>}
                    </div>
                    {/* } */}
                </div>}

            {selectedItems?.problems &&
                (<div className="d-flex flex-column gap-6">
                    <p class="text fs-14 font-b validate-color blue-bg w-max-content">Problems</p>
                    {Data?.EncounterProblem?.length > 0 ?
                        <div className="d-flex flex-column gap-1">
                            {Data.EncounterProblem.map((prob) => (
                                <div className="d-flex align-items-center gap-1">
                                    <p className='text font-m validate-color'>{prob.DiagnosisCode}</p>
                                    <p className="text text-black">{prob.Description && `- ${prob.Description}${prob.StartDate ? ',' : ''}`}</p>
                                    {prob.StartDate ?
                                        (<div className="d-flex align-items-center gap-1">
                                            <p className='heading text-black'>Start Date:</p>
                                            <p className='text text-black'>{prob.StartDate}</p>
                                        </div>) : <></>}
                                </div>
                            )
                            )}
                        </div> :
                        <>{noValExistText}</>}
                </div>)}


            {(selectedItems?.objective || (selectedItems?.currentMentalStatus || selectedItems?.objectiveNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">Objective</p>
                    </div>
                    {selectedItems?.currentMentalStatus &&
                        <div>
                            <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Current Mental Status</p>
                            <div className="">
                                <p className='heading text-black d-flex align-itemes-center gap-1 flex-wrap'>
                                    {(() => {
                                        const currentMentalStatusItems = [
                                            { key: "Orientation", label: "Orientation" },
                                            { key: "Insight", label: "Insight" },
                                            { key: "GeneralAppearance", label: "General Appearance" },
                                            { key: "JudgementAndImpulseControl", label: "Judgment/Impulse Control" },
                                            { key: "Dress", label: "Dress" },
                                            { key: "Memory", label: "Memory" },
                                            { key: "MotorActivity", label: "Motor Activity" },
                                            { key: "AttentionConcentration", label: "Attention/Concentration" },
                                            { key: "InterviewBehaviour", label: "Interview Behaviour" },
                                            { key: "ThoughtProcess", label: "Thought Process" },
                                            { key: "Speech", label: "Speech" },
                                            { key: "ThoughtContent", label: "Thought Content" },
                                            { key: "Mood", label: "Mood" },
                                            { key: "Perception", label: "Perception" },
                                            { key: "Affect", label: "Affect" },
                                            { key: "FunctionalStatus", label: "Functional Status" },
                                        ];

                                        // Filter only those that have values
                                        const filledVitals = currentMentalStatusItems.filter(v => currentMentalStatusData?.[v.key]);
                                        if (filledVitals?.length === 0) return noValExistText;
                                        // Map them into JSX
                                        return filledVitals.map((v, index) => (
                                            <React.Fragment key={v.key}>
                                                {v.label}:{" "}
                                                <span className="text text-black">
                                                    {`${currentMentalStatusData[v.key]}`}
                                                    {index < filledVitals.length - 1 && ", "}
                                                </span>
                                            </React.Fragment>
                                        ));
                                    })()}
                                </p>

                            </div>
                        </div>}
                    {selectedItems?.objectiveNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(objectiveNotesText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: objectiveNotesText }}></p>}
                            </div>
                        </div>}
                </div>}

            {(selectedItems?.intervention || (selectedItems?.interventionNotes || selectedItems?.interventionsUsed)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">Intervention</p>
                    </div>
                    {selectedItems?.interventionNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(interventionNotesText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: interventionNotesText }}></p>}
                            </div>
                        </div>}
                    {selectedItems?.interventionsUsed &&
                        <div>
                            <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Interventions Used</p>
                            <div className="d-flex flex-column gap-2">
                                {Object.entries(interventionCategories).map(([category, children]) => {
                                    // filter children that exist and are "true" in data
                                    const checkedChildren = children.filter(child => interventionsUsedData?.[child.key] === "true");

                                    if (checkedChildren.length === 0) return null; // skip empty category

                                    return (
                                        <div className="d-flex gap-20" key={category}>
                                            <p className="heading  min-w-160px text-black">{category}:</p>
                                            <div className="d-flex align-items-center flex-wrap row-gap-5 w-100">
                                                {checkedChildren.map(child => (
                                                    <div className="d-flex align-items-center gap-6 blue-tick col-md-4" key={child.key}>
                                                        <i className="icon-check fs-15 fw-900"></i>
                                                        <p className="text text-black">{child.label}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                                {/* // Show message if no interventions are checked */}
                                {!Object.values(interventionsUsedData || {}).some(val => val === "true") && noValExistText}
                            </div>
                        </div>}
                </div>}

            {(selectedItems?.response || (selectedItems?.responseNotes || selectedItems?.responseObservations)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">Response</p>
                    </div>
                    {selectedItems?.responseNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(responseNotesText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: responseNotesText }}></p>}
                            </div>
                        </div>}
                    {selectedItems?.responseObservations &&
                        <div>
                            <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Response Observations</p>
                            <div className="d-flex align-items-center gap-12">
                                {Object.entries(responseObservationsData || {}).map(([key, value]) => {
                                    // Only render if value exists
                                    if (!(value === "true")) {
                                        return null;
                                    }
                                    return (
                                        <div className="d-flex align-items-center gap-6 blue-tick" key={key}>
                                            <i className="icon-check fs-15 fw-900"></i>
                                            <p className="text text-black">{key}</p>
                                        </div>
                                    );
                                })}
                                {!Object.values(responseObservationsData || {}).some(val => val === "true") && noValExistText}
                            </div>
                        </div>}
                </div>}

            {(selectedItems?.assessment || (selectedItems?.riskAssessment || selectedItems?.assessmentNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">Assessment</p>
                    </div>
                    {selectedItems?.riskAssessment &&
                        <div>
                            <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Risk Assessment</p>
                            {(Data?.RiskAssessment || [])?.length > 0 ?
                                (Data?.RiskAssessment || [])?.map(assessment => {
                                    { console.log("RiskAssessment1123 assessment", assessment) }

                                    // Filter only those that have values
                                    const filledRiskAssessment = riskAssessmentItems.filter(ra => assessment?.[ra.key]);
                                    { console.log("RiskAssessment223 filledRiskAssessment", filledRiskAssessment) }
                                    // if (filledRiskAssessment?.length === 0) return noValExistText;
                                    // Map them into JSX
                                    return (<div className="d-flex align-items-center gap-1">
                                        <p className='text font-m cursor-pointer validate-color'>{assessment?.AreaOfRisk || 'N/A'}</p>
                                        {filledRiskAssessment.map((v, index) => (
                                            <>
                                                <p className='heading text-black'>{v.label}{" "}</p>
                                                <p className='text text-black'>{`${assessment[v.key]}`}{index < filledRiskAssessment.length - 1 && ", "}</p>
                                            </>
                                        ))}
                                    </div>)
                                }) : noValExistText}
                        </div>}
                    {selectedItems?.assessmentNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(assessmentNotesText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: assessmentNotesText }}></p>}
                            </div>
                        </div>}
                </div>}

            {(selectedItems?.plan || selectedItems?.prescriptions || selectedItems?.supplements || selectedItems?.vaccines
                || selectedItems?.injections || selectedItems?.labs || selectedItems?.imaging || selectedItems?.planNotes || selectedItems?.followUp) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">PLAN</p>
                    </div>
                    {selectedItems?.prescriptions &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Prescriptions</p>
                            {isVisuallyEmpty(Data.PrescriptionsNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: prescriptionsNotesText }}></p>}
                        </div>}
                    {selectedItems?.supplements &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Supplements</p>
                            {isVisuallyEmpty(Data.SupplementsNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: supplementsNotesText }}></p>}
                        </div>}
                    {selectedItems?.vaccines &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Vaccines</p>
                            {isVisuallyEmpty(Data.VaccinesNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: vaccinesNotesText }}></p>}
                        </div>}
                    {selectedItems?.injections &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Injections</p>
                            {isVisuallyEmpty(Data.InjectionsNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: injectionsNotesText }}></p>}
                        </div>}
                    {selectedItems?.labs &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Labs</p>
                            {isVisuallyEmpty(Data.LabsNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: labsNotesText }}></p>}
                        </div>}
                    {selectedItems?.imaging &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Imaging</p>
                            {isVisuallyEmpty(Data.ImagingNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: imagingNotesText }}></p>}
                        </div>}

                    {selectedItems?.planNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(planNotesText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: planNotesText }}></p>}
                            </div>
                        </div>}

                    {selectedItems?.followUp &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Follow-Up</p>
                            {isVisuallyEmpty(Data.FollowUpNotes) && !(Data?.FollowUpDate) ?
                                noValExistText :
                                <div>
                                    <div className="d-flex gap-1 text-nowrap mb-1">
                                        <p className='heading'>Follow-Up Date:</p>
                                        <p className='text'>{Data?.FollowUpDate || <span className="text ar-light-color">N/A</span>},</p>
                                    </div>
                                    <div className="d-flex flex-column gap-1">
                                        <p className='heading lh-12'>Notes:</p>
                                        {isVisuallyEmpty(Data.FollowUpNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: followUpNotesText }}></p>}
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>}

            {selectedItems?.customTemplateClinical &&
                (CustomTemplateData?.InsertPosition === "Bottom" ?
                    <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
            {(selectedItems?.additionalInfo || (selectedItems?.documents || selectedItems?.additionalNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">Additional INFO</p>
                    </div>
                    {selectedItems?.documents &&
                        <div>
                            <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Documents</p>
                            {Data?.EncounterDocument?.length > 0 ?
                                <div className="d-flex flex-column gap-1">
                                    {Data.EncounterDocument.map((doc) => (
                                        <div className="d-flex align-items-center gap-1">
                                            <p className='text font-m validate-color'>{doc.FileName}</p>
                                            <p className="text text-black">{doc.Description && `- ${doc.Description}`}</p>
                                        </div>
                                    )
                                    )}
                                </div> :
                                <>{noValExistText}</>}
                        </div>}
                    {selectedItems?.additionalNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(additionalNoteText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: additionalNoteText }}></p>}
                            </div>
                        </div>}
                </div>}

            {selectedItems?.procedureCodes &&
                <div className="d-flex flex-column gap-6">
                    <p class="text fs-14 font-b validate-color blue-bg w-max-content">Procedure Codes</p>
                    {Data?.mainServiceLineModal?.length > 0 ?
                        <div className="d-flex flex-column gap-1">
                            {Data.mainServiceLineModal.map((data) => {
                                let modifiersExists = [data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4].filter(Boolean)?.length > 0;
                                return (
                                    <div className="d-flex align-items-center gap-1 flex-wrap">
                                        <p className='text font-m validate-color'>{data?.ProcedureCode}</p>
                                        {data?.ProcedureDescription ? <p className="text text-black">{data?.ProcedureDescription && `- ${data.ProcedureDescription}`}</p> : null}
                                        {modifiersExists ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className="text text-black font-m">Modifiers:</p>
                                                <p className="heading text-black">
                                                    {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                        .filter(Boolean).join(', ')}
                                                    {data?.Units && !['1', 1, '1.00'].includes(data.Units) && ', '}
                                                </p>
                                            </div>) : <></>}
                                        {((data?.Units) && !['1', 1, "1.00"].includes(data.Units)) ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className="text text-black font-m">Units:</p>
                                                <p className="heading text-black">
                                                    {data?.Units}
                                                </p>
                                            </div>) : <></>}
                                    </div>
                                )
                            }
                            )}
                        </div> :
                        <>{noValExistText}</>}

                </div>}
            {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                <div className="d-flex">
                    <div className="ar-sign-new-design d-flex flex-column gap-1">
                        <div className="">
                            <SignImagePreview BucketPath={data?.Data?.SignaturePath} />
                        </div>
                        <p className="heading text-black">Electronically Signed By/Date:</p>
                        <p className='heading green-text'>{data?.Data?.ProviderSignBy || 'N/A'} on {signatureDateTimeFormatted || 'N/A'}</p>
                        {/* <div className="d-flex align-items-center gap-1">
                            <p className='heading text-black'>Sign Off Status:</p>
                            {(searchValue?.EncounterStatus === 'Signed' || data?.Data?.EncounterStatus === 'Signed') ?
                                <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                                searchValue?.EncounterStatus === 'In Progress' ?
                                    <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                                    searchValue?.EncounterStatus === 'Ready for Review' ?
                                        <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                                        ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                                        <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}
                        </div> */}
                    </div>
                </div>
                :
                null}

            {EncounterCoSignData?.map(it => 
                <SignData data={it}/>
            )}
            <div className='text-center pt-1-5 br-top-1 za_br_light'>
                <p className="text ar-light-color">Note Generated by {ThemeConfiguration?.configuration?.company?.name} (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer" >https://starhealthcare.co</a>)</p>
                {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTC}</p>
                <p className="text ar-light-color">Generated for Printing on: 11/6/2025 at 09:50 AM UTC</p> */}
                <p className="text ar-light-color">Printed by {data?.Data?.UserName || 'N/A'} on {formattedUTC}</p>
                {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTCBottom}</p> */}
            </div>
        </div>
    </>)
}

export default SelectedPreviewDataV2